import { FC } from 'react';
import { Divider, Text, Tooltip, NavLink, ThemeIcon } from '@mantine/core';
import { IconTriangle, IconSquare, IconEdit, IconHexagon, IconStack3, IconDashboard } from '@tabler/icons-react';
import { useNavigate } from 'react-router-dom';

// internal
import {
  closeloopAdmin,
  closeloopViewer,
  closeloopWriter,
  dashboardWriter,
  deploymentAdmin,
  deploymentViewer,
  deploymentWriter,
  generateLinkViewer,
  generateLinkWriter,
  quotaCallcenterViewer,
  quotaCallcenterWriter,
  quotaLimitViewer,
  quotaLimitWriter,
  surveyAdmin,
  surveyViewer,
  surveyWriter,
  transactionAdmin,
  transactionViewer,
  transactionWriter,
} from 'constants/permission';
import { useProjectStore } from 'apps/composer-app/src/store/project';
import { usePermissionStore } from 'apps/composer-app/src/store/permission';

const data = [
  {
    icon: <IconDashboard />,
    color: 'dark',
    label: 'Dashboard',
    path: '/manage/dashboard',
    subMenu: [],
    key: [dashboardWriter],
  },
  {
    icon: <IconSquare />,
    color: 'dark',
    label: 'Deployment',
    path: '/manage/deployment',
    subMenu: [],
    key: [deploymentViewer, deploymentWriter, deploymentAdmin],
  },
  {
    icon: <IconTriangle />,
    color: 'dark',
    label: 'Transaction',
    path: '/manage/transaction/group',
    subMenu: [],
    key: [transactionViewer, transactionWriter, transactionAdmin],
  },
  {
    icon: <IconEdit />,
    color: 'dark',
    label: 'Survey',
    path: '/manage/survey',
    key: [surveyViewer, surveyWriter, surveyAdmin, generateLinkViewer, generateLinkWriter],
    subMenu: [
      {
        icon: <IconEdit />,
        color: 'dark',
        label: 'Builder',
        path: '/manage/survey/builder',
        key: [surveyViewer, surveyWriter, surveyAdmin],
      },
      {
        icon: <IconEdit />,
        color: 'dark',
        label: 'Preview',
        path: '/manage/survey/preview',
        key: [surveyViewer, surveyWriter, surveyAdmin],
      },
      {
        icon: <IconEdit />,
        color: 'dark',
        label: 'Generate Link',
        path: '/manage/survey/generate-link',
        key: [generateLinkViewer, generateLinkWriter],
      },
      {
        icon: <IconEdit />,
        color: 'dark',
        label: 'Data Collection',
        path: '/manage/survey/data-collection',
        //TODO: should use data collection permission
        key: [surveyViewer, surveyWriter, surveyAdmin],
      },
    ],
  },
  // {
  //   icon: <IconHexagon />,
  //   color: 'dark',
  //   label: 'Closeloop',
  //   path: '/manage/closeloop/case',
  //   subMenu: [],
  //   key: [closeloopViewer, closeloopWriter, closeloopAdmin],
  // },
  // {
  //   icon: <AntennaBars5 />,
  //   color: 'dark',
  //   label: 'Report',
  //   path: '/report',
  //   subMenu: [
  //     {
  //       icon: <AntennaBars5 />,
  //       color: 'dark',
  //       label: 'Report_child',
  //       path: '/report_child',
  //     },
  //   ],
  //   key: reportViewer,
  // },
  {
    icon: <IconStack3 />,
    color: 'dark',
    label: 'Quota',
    path: '/manage/quota',
    subMenu: [
      {
        icon: <IconStack3 />,
        color: 'dark',
        label: 'Response Limit',
        path: '/manage/quota/response-limit',
        key: [quotaLimitViewer, quotaLimitWriter],
      },
      {
        icon: <IconStack3 />,
        color: 'dark',
        label: 'Call Center',
        path: '/manage/quota/call-center',
        key: [quotaCallcenterViewer, quotaCallcenterWriter],
      },
    ],
    key: [quotaLimitViewer, quotaLimitWriter, quotaCallcenterViewer, quotaCallcenterWriter],
  },
];

const NavMenu: FC = () => {
  const navigate = useNavigate();

  const projectStore = useProjectStore((state) => ({
    projectName: state.name,
  }));

  const permissionStore = usePermissionStore((state) => ({
    checkPermission: state.checkPermissionNew,
  }));

  const onClick = (path: string, subMenu: unknown[] = []) => {
    if (subMenu.length <= 0) {
      navigate(path);
    }
  };

  const links = data
    .filter((item) => item.path === '/manage/dashboard' || permissionStore.checkPermission(item.key))
    .map((link) => (
      <NavLink
        key={link.path}
        label={
          <Text size="md" c="brand">
            {link.label}
          </Text>
        }
        leftSection={<ThemeIcon variant="light">{link.icon}</ThemeIcon>}
        color="gray"
        childrenOffset={28}
        className="rounded-md focus:bg-gray-200"
        onClick={() => onClick(link.path, link.subMenu)}
      >
        {link.subMenu.length > 0 &&
          link.subMenu
            .filter((item) => permissionStore.checkPermission(item.key))
            .map((child) => (
              <NavLink
                key={child.label}
                label={
                  <Text size="md" c="brand">
                    {child.label}
                  </Text>
                }
                color="gray"
                className="rounded-md focus:bg-gray-200"
                onClick={() => onClick(child.path)}
              />
            ))}
      </NavLink>
    ));

  return (
    <>
      <div className="px-2 mb-2 ">
        <Tooltip label={projectStore.projectName} color="gray" withArrow>
          <Text className="mb-2 font-bold" c="brand" size="md" truncate>
            {projectStore.projectName}
          </Text>
        </Tooltip>
        <Divider />
      </div>
      <div>{links}</div>
      {/* TODO: Bottom display menu */}
      {/* <div className="flex flex-col justify-end h-full">
        <Button leftSection={<IconIndentDecrease className="text-white" size={30} />}>Toggle Menu</Button>
      </div> */}
    </>
  );
};

export default NavMenu;
